export const ymCounterCommon = 93302549
